import { Component } from 'react';

import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'providers';
import { Route, Routes } from 'react-router-dom';
import { flowRight as compose } from 'lodash';

import AddAccount from './AddAccount';
import AddAccountInfo from './AddAccountInfo';
import AddVehicle from './AddVehicle';
import DriverDetails from './Details';
import styles, { BootstrapInput, OptionLabelText, SearchOptionContainer, SearchSelect, SearchText } from './styles';

import { Pagination } from '@mui/material';
import acl from 'constants/acl';

class DriverList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchField: 'name',
      openFilter: false,
      searching: false,
    };
  }

  statusColorMap = {
    CREATED: '#bebfc0',
    BACKGROUND_APPROVED: '#4a90e2',
    APPROVED: '#4a90e2',
    ACTIVE: '#7ed321',
    INACTIVE: '#d0021b',
    SUSPENDED: '#d0021b',
  };

  componentDidMount() {
    const { store } = this.props;
    const driverDetailsMatch = this.props.location.pathname.match(/\/drivers\/[\d]+\/info/gi);

    if (!driverDetailsMatch) store.driverStore.getDrivers();
  }

  handleSearchFieldChange = (event) => {
    const { driverStore } = this.props.store;
    driverStore.searchField = event.target.value.trim();
    driverStore.page = 0;
  };

  handleSearchKeywordChange = (event) => {
    const { driverStore } = this.props.store;
    driverStore.searchKeyword = event.target.value.trim();
    driverStore.page = 0;
  };

  clearSearch = (event) => {
    const { driverStore } = this.props.store;
    driverStore.searchKeyword = '';
    driverStore.page = 0;
    this.setState(
      {
        searching: true,
      },
      () => {
        driverStore.getDrivers((res) => {
          this.setState({ searching: false });
        });
      },
    );
  };

  onSelectPage = (page) => {
    const { driverStore } = this.props.store;
    driverStore.page = page - 1;
    driverStore.getDrivers();
  };

  addDriver = () => {
    this.props.history.push('/drivers/add-account-info');
  };

  gotoDetails = (id) => () => {
    this.props.history.push(`/drivers/${id}/info`);
  };

  searchDriver = (e) => {
    const { store } = this.props;
    this.setState(
      {
        searching: true,
      },
      () => {
        store.driverStore.getDrivers((res) => {
          this.setState({ searching: false });
        });
      },
    );
    e.preventDefault();
    return false;
  };

  setOpen = () => this.setState({ openFilter: true });

  setClose = () => this.setState({ openFilter: false });

  toggle = () => this.setState({ openFilter: !this.state.openFilter });

  onSearchEnter = (e) => {
    if (e.keyCode === 13) {
      this.searchDriver(e);
    }
  };

  render() {
    const { store } = this.props;
    const { permissionStore } = store;
    const { data, searchKeyword, searchField } = store.driverStore;
    let totalPage = 0;

    if (data?.count && data.count > 0) {
      totalPage = Math.floor(data.count / 20) + 1;
      if (totalPage === 1) totalPage = 0;
    }

    const driverDetailsMatch = this.props.location.pathname.match(/\/drivers\/[\d]+\/info/gi);
    const isDeniedCreateDriver = permissionStore.isDenied(acl.DRIVERS.CREATE);

    return (
      <Container maxWidth={false} sx={styles.root}>
        {!driverDetailsMatch && (
          <Box>
            <Grid justifyContent="flex-end" container spacing={3}>
              <Grid>
                {!isDeniedCreateDriver && (
                  <Button
                    variant="contained"
                    size="small"
                    disableElevation
                    onClick={this.addDriver}
                  >{`+ NEW`}</Button>
                )}
              </Grid>
            </Grid>
            <Box my={2}>
              <Grid container spacing={1}>
                <Grid>
                  <SearchOptionContainer onClick={this.toggle}>
                    <OptionLabelText>{`Search by`}</OptionLabelText>
                    {this.state.openFilter ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                    <SearchSelect
                      open={this.state.openFilter}
                      value={searchField}
                      onChange={this.handleSearchFieldChange}
                      onOpen={() => this.setOpen()}
                      onClose={() => this.setClose()}
                      input={<BootstrapInput />}
                      style={{ border: 'none', background: 'transparent' }}
                      IconComponent={() => null}
                    >
                      <MenuItem value={'name'}>{`Name`}</MenuItem>
                      <MenuItem value={'phone_number'}>{`Phone Number`}</MenuItem>
                      <MenuItem value={'id'}>{`Driver ID`}</MenuItem>
                    </SearchSelect>
                  </SearchOptionContainer>
                </Grid>
                <Grid flex={1}>
                  <form onSubmit={this.searchDriver}>
                    <TextField
                      fullWidth
                      placeholder="Search drivers here..."
                      value={searchKeyword}
                      onChange={this.handleSearchKeywordChange}
                      variant="outlined"
                      size="small"
                      slotProps={{
                        input: {
                          sx: {
                            bgcolor: '#fff',
                          },
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon fontSize="small" />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={this.clearSearch} size="small" edge="end">
                                <CloseIcon />
                              </IconButton>
                            </InputAdornment>
                          ),
                        },
                      }}
                    />
                  </form>
                </Grid>
                <Grid>
                  <Button
                    loading={this.state.searching}
                    onClick={this.searchDriver}
                    variant="contained"
                    color="primary"
                    disableElevation
                    size="small"
                    sx={{ height: 40 }}
                  >
                    Search
                  </Button>
                </Grid>
              </Grid>
            </Box>
            {data.drivers && data.drivers.length > 0 && (
              <Container maxWidth={false} style={{ padding: 0 }}>
                <Grid container justifyContent="space-between" direction="row" alignItems="stretch" spacing={2}>
                  {data.drivers.map((driver, i) => {
                    const statusColor = this.statusColorMap[driver.status] ? this.statusColorMap[driver.status] : '#bebfc0';

                    return (
                      <Grid
                        size={6}
                        key={driver.id}
                        sx={styles.driverItemWrapper}
                        onClick={this.gotoDetails(driver.id)}
                        alignItems={'center'}
                      >
                        <Paper sx={styles.driverItem} elevation={0} square>
                          <Grid container spacing={3}>
                            <Grid size={6}>
                              <Grid container>
                                <Grid>
                                  <Avatar variant="square" alt={driver.first_name} sx={{ width: 60, height: 60 }} src={driver.photo} />
                                </Grid>
                                <Grid sx={{ ...styles.itemColumn, ...styles.itemDriverName }}>
                                  {driver.first_name} {driver.last_name}
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid size={2} sx={{ ...styles.itemColumn, ...styles.columnPhone }}>
                              {driver.phone_number}
                            </Grid>
                            <Grid size={4} sx={{ ...styles.itemColumn, ...styles.columnStatus }}>
                              <Box component="span" sx={{ ...styles.driverStatus, color: statusColor }}>
                                {driver.status}
                              </Box>{' '}
                              <IconButton aria-label="delete" disabled color="primary" size="large">
                                <ArrowForwardIosIcon style={{ color: '#bfbfbf', fontSize: '12px' }} />
                              </IconButton>
                            </Grid>
                          </Grid>
                        </Paper>
                      </Grid>
                    );
                  })}
                </Grid>
                <Grid container direction="row" justifyContent="center" alignItems="center">
                  <Grid style={{ padding: '10px 0' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                      {totalPage > 0 && (
                        <Pagination
                          count={totalPage}
                          page={data.page + 1}
                          onChange={(e, page) => this.onSelectPage(page)}
                          color="primary"
                          size="small"
                        />
                      )}
                    </Box>
                  </Grid>
                </Grid>
              </Container>
            )}
          </Box>
        )}
        <Routes>
          <Route path=":id/info" element={<DriverDetails />} />
          <Route path="add-account-info" element={<AddAccountInfo />} />
          <Route path="add-vehicle" element={<AddVehicle />} />
          <Route path="add-account" element={<AddAccount />} />
        </Routes>
      </Container>
    );
  }
}

export default compose(withRouter, inject('store'), observer)(DriverList);
